<div class="task-info-card task-info-card--{{ task.status }}">
  <p class="task-info-card__item">
    <strong>STATUS:</strong> {{ task.status | requestStatusEnum }}
  </p>
  <p class="task-info-card__item">
    <strong>DATA DE ABERTURA:</strong> {{ task.created_at | date: "dd/MM/yyyy - HH:mm" }}
  </p>
  <p class="task-info-card__item">
    <strong>DATA DE ENCERRAMENTO:</strong>
    {{ task.status !== "pending" ? (task.updated_at | date: "dd/MM/yyyy - HH:mm") : "-" }}
  </p>
  <p class="task-info-card__item">
    <strong>CÓD. TASK:</strong> {{ task.id }}
  </p>
  <p class="task-info-card__item">
    <strong>CATEGORIA:</strong> {{ task.task_type | taskType }}
  </p>
  @if (task.task_type === TaskType.WITHDRAWAL || task.task_type === TaskType.REFUND) {
    <p class="task-info-card__item">
      <strong>VALOR:</strong> {{ task.amount | currency: "BRL" : "symbol" : "1.2-2" }}
    </p>
  }
  @if (task.task_type === TaskType.WITHDRAWAL && task.documents?.length) {
    <div class="task-info-card__item">
      <strong>NOTA FISCAL:</strong>
      <ul class="task-info-card__docs">
        @for (document of task.documents; track document.id) {
          <li>
            <a [href]="document.url" target="_blank" rel="noopener noreferrer">
              {{ document.title || "Nota fiscal" }}
            </a>
          </li>
        }
      </ul>
    </div>
  }
</div>
